// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #21212156;
  z-index: 9999; }
  .deleteModal__container {
    width: 560px;
    height: 360px;
    background: #ffffff;
    box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
    border-radius: 4px;
    padding: 20px;
    position: relative; }
    .deleteModal__container h1 {
      font-weight: 600;
      font-size: 24px;
      line-height: 150%;
      margin-bottom: 10px; }
    .deleteModal__container p {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 10px; }
    .deleteModal__container span,
    .deleteModal__container ul {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      list-style-type: disc;
      list-style-position: inside; }
    .deleteModal__container li {
      margin-left: 10px; }
  .deleteModal__footer {
    display: flex;
    position: absolute;
    gap: 10px;
    bottom: 20px;
    right: 20px; }
    .deleteModal__footer_button {
      width: 75px;
      padding: 4px 0;
      border: none;
      cursor: pointer;
      transition: all 0.4s;
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px; }
    .deleteModal__footer_cancel {
      background: #ffffff;
      color: #fe6100; }
      .deleteModal__footer_cancel:hover {
        background: #fe6100;
        color: #ffffff; }
    .deleteModal__footer_remove {
      background: #e00606;
      color: #ffffff; }
      .deleteModal__footer_remove:hover {
        background: #fe6100; }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/delete/deleteModal.scss"],"names":[],"mappings":"AAAA;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa,EAAA;EACb;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;IACb,kBAAkB,EAAA;IAPnB;MASG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,mBAAmB,EAAA;IAZtB;MAeG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,mBAAmB,EAAA;IAlBtB;;MAsBG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,qBAAqB;MACrB,2BAA2B,EAAA;IA1B9B;MA6BG,iBAAiB,EAAA;EAGrB;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW,EAAA;IACX;MACE,WAAW;MACX,cAAc;MACd,YAAY;MACZ,eAAe;MACf,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,mBAAmB;MACnB,cAAc,EAAA;MAFf;QAIG,mBAAmB;QACnB,cAAc,EAAA;IAGlB;MACE,mBAAmB;MACnB,cAAc,EAAA;MAFf;QAIG,mBAAmB,EAAA","sourcesContent":[".deleteModal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #21212156;\n    z-index: 9999;\n    &__container {\n      width: 560px;\n      height: 360px;\n      background: #ffffff;\n      box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n      border-radius: 4px;\n      padding: 20px;\n      position: relative;\n      h1 {\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 150%;\n        margin-bottom: 10px;\n      }\n      p {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        margin-bottom: 10px;\n      }\n      span,\n      ul {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        list-style-type: disc;\n        list-style-position: inside;\n      }\n      li {\n        margin-left: 10px;\n      }\n    }\n    &__footer {\n      display: flex;\n      position: absolute;\n      gap: 10px;\n      bottom: 20px;\n      right: 20px;\n      &_button {\n        width: 75px;\n        padding: 4px 0;\n        border: none;\n        cursor: pointer;\n        transition: all 0.4s;\n        border-radius: 4px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 24px;\n      }\n      &_cancel {\n        background: #ffffff;\n        color: #fe6100;\n        &:hover {\n          background: #fe6100;\n          color: #ffffff;\n        }\n      }\n      &_remove {\n        background: #e00606;\n        color: #ffffff;\n        &:hover {\n          background: #fe6100;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
